import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Components
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';

// Images
import blogdetails1 from '../../Images/blogdetails1.jpeg';
import agra2 from '../../Images/blogdetails2.jpeg';
import agra3 from '../../Images/blogdetails3.jpeg';
import agra4 from '../../Images/blogdetails1.jpeg';

// SEO Hook
import useSEO from '../../Hooks/UseSeo';
import BlogDetailsDelhi from './BlogdetailsDelhi';
import BlogDetailsShimla from './BlogDetailsShimla';

// ALL BLOG DATA (each slug → separate page)
export const blogDetailsData = {
  'top-must-visit-places-in-agra': {
    title: 'Top Must-Visit Places in Agra',
    seoTitle: 'Top Must-Visit Places in Agra | Pick Quick Cabs Blog',
    seoDescription:
      'Explore the top attractions in Agra with Pick Quick Cabs and experience comfort and convenience during your trip.',
    heroImg: blogdetails1,

    content: (navigate) => (
      <>
        <Header />

        {/* Hero Section */}
        <div
          className="relative mt-32 h-[50vh] flex items-center justify-center text-center text-white px-4"
          style={{
            backgroundImage: `url(${blogdetails1})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="bg-black/50 p-4 rounded">
            <h1 className="text-3xl sm:text-5xl font-bold">
              Top Must-Visit Places in Agra
            </h1>
          </div>
        </div>

        {/* Blog Content */}
        <div className="max-w-5xl mx-auto px-6 py-12 leading-relaxed text-gray-800">
          <h2 className="text-2xl font-bold mb-4">
            Top Must-Visit Places in Agra: Explore the City of Wonders with the
            Best Agra Cab & Taxi Services
          </h2>
          <p className="text-lg mb-6">
            Agra, the city of love and grandeur, is a timeless gem on the map of
            India. Famed for its world-renowned Taj Mahal, Agra is much more
            than just a monument; it’s a gateway to a rich historical heritage,
            majestic architecture, bustling markets, and vibrant culture.
            Whether you’re planning a quick weekend getaway or a deep dive into
            history, Agra has something for every traveler. And with reliable
            Agra cab service and Agra taxi service, your journey becomes even
            more comfortable and convenient. If you’re coming from the bustling
            capital, using a Delhi to Agra cab service or Delhi to Agra taxi
            service is the best way to kickstart your Agra adventure. In this
            comprehensive guide, let’s explore the top must-visit places in Agra
            and discover how using local cab and taxi services can elevate your
            travel experience.
          </p>

          <img
            src={agra2}
            alt="Agra view"
            className="rounded-2xl shadow-lg mb-8"
          />

          <h2 className="text-2xl font-bold mb-4">1. The Iconic Taj Mahal</h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            No trip to Agra is complete without witnessing the ethereal beauty
            of the Taj Mahal. This UNESCO World Heritage Site, built by Emperor
            Shah Jahan in memory of his beloved wife Mumtaz Mahal, stands as a
            symbol of eternal love. The gleaming white marble structure glows
            with changing hues during sunrise and sunset, creating a magical
            aura.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            Located at the heart of Agra, the Taj Mahal is easily accessible by
            pick quick cabs taxi service. Booking a cab ensures you avoid
            parking hassles and reach comfortably, especially if you want to
            catch the sunrise view.
          </p>

          <h2 className="text-2xl font-bold mb-4">2. Agra Fort</h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            A UNESCO World Heritage Site, Agra Fort is an architectural
            masterpiece. Explore its grand halls, intricate palaces, and
            beautiful gardens. The fort offers panoramic views of the Taj Mahal
            from its balconies—a favorite spot for photographers.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            Traveling between monuments is hassle-free with pick quick cabs.
            <span
              onClick={() => navigate('/')}
              className=" cursor-pointer font-bold hover:text-yellow-500"
            >
              {' '}
              Pick quick cabs
            </span>{' '}
            cab offer customizable packages, allowing you to visit multiple
            sites in a day.
          </p>

          <img
            src={agra3}
            alt="Agra Fort"
            className="rounded-2xl shadow-lg mb-8"
          />

          <h2 className="text-2xl font-bold mb-4">
            3. Fatehpur Sikri: The Abandoned City
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            Just 40 km from Agra, Fatehpur Sikri is a perfectly preserved ghost
            city and a UNESCO World Heritage Site. Founded by Emperor Akbar, its
            red sandstone buildings narrate tales of Mughal grandeur. Don’t miss
            the Buland Darwaza, Jama Masjid, and the tomb of Salim Chishti.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            The best way to visit Fatehpur Sikri is by{' '}
            <span
              onClick={() => navigate('/book-a-ride')}
              className=" cursor-pointer font-bold hover:text-yellow-500"
            >
              {' '}
              booking an Agra cab service
            </span>{' '}
            for a comfortable half-day trip, or opt for a Delhi to Agra taxi
            service if you’re traveling onwards from the capital.
          </p>

          <h2 className="text-2xl font-bold mb-4">
            4. Mehtab Bagh: The Garden with a View
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            If you want that perfect, crowd-free shot of the Taj Mahal, Mehtab
            Bagh is the place to be. Situated across the Yamuna River, this
            garden offers a unique view of the monument, especially during
            sunset.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            Arrange an Agra taxi service for a relaxing drive to Mehtab Bagh.
            Pick quick cabs cab providers offer sightseeing packages that
            include this hidden gem.
          </p>

          <h2 className="text-2xl font-bold mb-4">
            5. Itimad-ud-Daulah’s Tomb: The Baby Taj
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            Known as the "Baby Taj," this exquisite tomb predates the Taj Mahal
            and is considered its inspiration. The delicate marble lattice work
            and serene gardens make it a must-visit for architecture
            enthusiasts.
          </p>

          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            A short ride with an Agra cab service will take you to this peaceful
            site, perfect for those seeking tranquility away from the crowds.
          </p>

          <h2 className="text-2xl font-bold mb-4">6. Akbar’s Tomb, Sikandra</h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            Located at Sikandra, Akbar’s Tomb is a blend of Hindu, Christian,
            Islamic, Buddhist, and Jain motifs, reflecting the emperor’s secular
            vision. The sprawling gardens and intricate carvings are a delight
            for history lovers.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            Simply hire an Agra taxi service to explore Sikandra at your own
            pace. Pick Quick Cabs cab drivers are knowledgeable and can guide
            you through the site’s highlights.
          </p>

          <h2 className="text-2xl font-bold mb-4">
            7. Jama Masjid: The Spiritual Center
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            One of the largest mosques in India, Jama Masjid in Agra is a
            testament to Mughal craftsmanship. Its red sandstone and white
            marble architecture is both imposing and beautiful.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            With pick quick cabs, you can include Jama Masjid in your city tour
            with ease, ensuring a seamless sightseeing experience.
          </p>

          <h2 className="text-2xl font-bold mb-4">
            8. Shopping in Agra: Sadar Bazaar & Kinari Bazaar
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            Agra isn’t just about monuments; it’s a paradise for shoppers. Pick
            up exquisite marble handicrafts, leather goods, carpets, jewelry,
            and of course, the famous Petha sweet. Sadar Bazaar and Kinari
            Bazaar are the city’s most popular markets.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            After a day of monument hopping, let your taxi service take you to
            these bustling markets. Your cab can also help carry all those
            shopping bags!
          </p>

          <h2 className="text-2xl font-bold mb-4">
            9. Mughal Gardens: Ram Bagh & Soami Bagh
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            Agra’s gardens are a peaceful retreat after a day of sightseeing.
            Ram Bagh, the oldest Mughal Garden in India, and Soami Bagh, known
            for its temple, are ideal for relaxation.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            Add these stops to your itinerary when booking pick quick cabs for a
            full city tour.
          </p>

          <h2 className="text-2xl font-bold mb-4">
            10. Wildlife SOS: The Bear and Elephant Rescue Center
          </h2>
          <h2 className="text-xl font-bold mb-4">Why Visit?</h2>
          <p className="mb-4">
            For animal lovers, a visit to Wildlife SOS offers an educational
            experience. This rescue center works to protect India’s sloth bears
            and elephants. Pre-book your visit for a guided tour.
          </p>
          <h2 className="text-xl font-bold mb-4">How to Reach?</h2>
          <p className="mb-4">
            Wildlife SOS is a bit outside the city, so hiring pick quick cabs is
            the most convenient way to reach the center safely and comfortably.
          </p>

          <img
            src={agra4}
            alt="Mehtab Bagh"
            className="rounded-2xl shadow-lg mb-8"
          />

          <h2 className="text-2xl font-bold mb-4">Why Use Pick Quick Cabs?</h2>
          <h2 className="mb-4">
            Exploring Agra’s many treasures is best done at your own pace, and
            nothing beats the comfort and convenience of a reliable Agra cab
            service or Agra taxi service. Here’s why:
          </h2>

          <ul className="list-disc list-inside mb-6 space-y-2">
            <li>
              Time Efficiency: Avoid waiting for buses or autos. With a taxi,
              you maximize your sightseeing time.
            </li>
            <li>
              Comfort: Air-conditioned cabs provide respite from Agra’s weather,
              especially in summers.
            </li>
            <li>
              Safety: Professional drivers know the city routes and ensure a
              hassle-free journey.
            </li>
            <li>
              Custom Itineraries: Plan your day as you wish; most cab services
              offer flexible choices.
            </li>
            <li>
              Local Insights: Many drivers double as local guides, sharing
              stories and tips.
            </li>
            <li>
              Group Travel: Traveling with family or friends? Choose a cab size
              that suits your group.
            </li>
          </ul>
          <h2 className="text-2xl font-bold mb-4">
            <span
              onClick={() => navigate('/delhi-to-agra-taxi-service')}
              className=" cursor-pointer font-bold hover:text-yellow-500"
            >
              Delhi to Agra Cab Service:
            </span>{' '}
            The Best Way to Start Your Journey
          </h2>
          <h2 className="mb-4">
            If you’re traveling from Delhi, the best way to reach Agra is by
            booking Pick Quick Cabs. Here’s why:
          </h2>

          <ul className="list-disc list-inside mb-6 space-y-2">
            <li>
              Door-to-Door Convenience: Get picked up from your location in
              Delhi and dropped at your Agra hotel or monument of choice.
            </li>
            <li>
              Relaxed Journey: Enjoy the scenic Yamuna Expressway in a
              comfortable cab, rather than dealing with the hassle of buses or
              trains.
            </li>
            <li>
              Flexible Stops: Want to visit Mathura or Vrindavan en route? Just
              ask your driver!
            </li>
            <li>
              Round-Trip Packages:Pick Quick Cabstaxi services offer same-day
              return options or multi-day packages for extended trips.
            </li>
            <li>
              Safety & Hygiene:Pick Quick Cabs cab services maintain high
              standards of cleanliness and safety.
            </li>
          </ul>

          <h2 className="mb-4">Tips for Booking Agra Cabs and Taxis</h2>

          <ul className="list-disc list-inside mb-6 space-y-2">
            <li>
              Book in Advance: Especially during peak tourist seasons, advance
              booking ensures availability and better rates.
            </li>
            <li>
              Check Reviews: Use platforms with genuine user reviews to select a
              reliable service.
            </li>
            <li>
              Compare Packages: Look for city tours, outstation trips, and
              hourly rentals to match your needs.
            </li>
            <li>
              Clarify Inclusions: Confirm what’s included—fuel, tolls, driver
              charges, etc.
            </li>
            <li>
              Stay Connected: Share your cab details with a friend or family
              member for added safety.
            </li>
            <li>Conclusion: Uncover Agra’s Magic with Comfort</li>
          </ul>
          <p className="py-4">
            Agra is a city that lingers in your memory long after you leave.
            Whether you’re marveling at the Taj Mahal, exploring vibrant
            markets, or savoring local delicacies, every moment in Agra is
            special. And with the support of the best Agra cab service and Agra
            taxi service, your journey becomes smoother, safer, and more
            enjoyable.
          </p>
          <p className=" py-4">
            If you’re coming from Delhi, don’t think twice—book a Delhi to Agra
            cab service or Delhi to Agra taxi service for the ultimate travel
            experience. Explore the wonders of Agra at your own pace, with the
            comfort and convenience you deserve.
          </p>
          <p className=" py-4">
            Ready to embark on your Agra adventure? Book your cab, pack your
            bags, and let Agra’s timeless beauty enchant you!
          </p>
        </div>

        <Footer />
      </>
    )
  },

  'top-must-visit-places-in-delhi': {
    title: 'Cheap Long Distance Travel Tips',
    seoTitle: 'Cheap Long Distance Travel Tips | Pick Quick Cabs Blog',
    seoDescription:
      'Discover smart tips for cheap travel with expert guidance.',
    heroImg: blogdetails1,

    content: () => <BlogDetailsDelhi />
  },

  'best-weekend-road-trips-from-delhi-to-shimla': {
    title: 'Best Weekend Road Trips from Delhi to Shimla',
    seoTitle:
      'Best Weekend Road Trips from Delhi to Shimla | Pick Quick Cabs Blog',
    seoDescription:
      'Plan the perfect weekend road trip from Delhi to Shimla with travel tips, routes, and cab options.',
    heroImg: blogdetails1,

    content: () => <BlogDetailsShimla />
  }
};

export default function BlogDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Get current page data
  const blog = blogDetailsData[slug];

  // ❌ Invalid Slug → Show Simple 404
  if (!blog) {
    return (
      <div className="mt-40 text-center">
        <h1 className="text-5xl font-bold">404</h1>
        <p className="text-xl mt-2">Blog Not Found</p>
      </div>
    );
  }

  // Render the blog content
  return <>{blog.content(navigate)}</>;
}
